import { render } from "./fields.vue?vue&type=template&id=eddc3ba8"
import script from "./fields.vue?vue&type=script&lang=js"
export * from "./fields.vue?vue&type=script&lang=js"

import exportComponent from "/home/docuseal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/template_builder/fields.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "eddc3ba8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('eddc3ba8', __exports__)) {
    api.reload('eddc3ba8', __exports__)
  }
  
  module.hot.accept("./fields.vue?vue&type=template&id=eddc3ba8", () => {
    api.rerender('eddc3ba8', render)
  })

}


export default __exports__